import React from 'react';

import {Link} from '../../../../lib/routes';

import {linkClass} from './link-style';

type Props = {
	args: string[];
	name: string;
};

// {@feat feat-id, Название черты}
export const FeatPlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	return (
		<Link route={'feat'} params={{id}} title={title} className={linkClass('feat')}>
			{title}
		</Link>
	);
};
